module.exports = __webpack_public_path__ + "static/media/rent.6c278f92.svg";